import bp from '@bbl-digital/snorre/lib/globals/styles/breakpoints'
import styled from '@emotion/styled'

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.5em;
  /* margin: 0.5em 1em; */
  /* 
  @media screen and (max-width: ${bp.medium}) {
    margin-left: 0;
  } */
`

export const WrapperContent = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 0.5em;
  margin: 0.5em 0;

  @media screen and (max-width: ${bp.medium}) {
    flex-direction: column;
    align-items: flex-end;
    width: 100%;
  }
`

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const DropdownWrapper = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-column-gap: 1em;
  align-items: center;

  & > span > button {
    line-height: 1.2;
  }

  @media screen and (max-width: ${bp.medium}) {
    grid-auto-flow: row;
    grid-row-gap: 0.5em;
    grid-row-gap: 0.5em;
    text-align: left;

    & > span {
      position: relative;

      & > div {
        width: 250px;
        right: 0;
      }
    }
  }
`
